module.exports = __webpack_public_path__ + "static/img/logo8.19ef6d91.jpg";